import {_utils, viewportChecker} from "../../utils/_utils.js";
import {_state} from "../../state/state.js";
import {_libs} from "../../utils/_libs.js";

export const sectionWithSwiper = () => {
    return new Promise((resolve, reject) => {
        _utils.initSection('.section-with-swiper', (section, sectionIndex) => init(section, sectionIndex));
        resolve();
    })
}

const init = (section, sectionIndex) => {
    const sliderDesk = section.querySelector('.swiper');
    const sliderTablet = section.querySelector('.swiper');
    const sliderMobile = section.querySelector('.swiper');

    let swiper = null;

    const createSwiper = () => {
        if (swiper !== null) {
            swiper.destroy(true, true);
            swiper = null;
        }
        if(_state.isDesktop && sliderDesk){
            swiper = _libs._swiper(sliderDesk, {
                slidesPerView: 'auto',
                speed: 800,
                spaceBetween: 10,
                keyboard: {
                    enabled: true,
                },
                autoplay: {
                    disableOnInteraction: false,
                    delay: 6000,
                    pauseOnMouseEnter: true,
                },
                on: {
                    init: swiper => {
                        let isAutoplayStopped = false;
                        if(!section.classList.contains('s-visible')){
                            swiper.autoplay.stop();
                            isAutoplayStopped = true;
                        }
                        section.addEventListener('sVisible', () => {
                            if (isAutoplayStopped) {
                                swiper.autoplay.start();
                                isAutoplayStopped = false;
                            }
                        })
                        section.addEventListener('sHidden', () => {
                            if (!isAutoplayStopped) {
                                swiper.autoplay.stop();
                                isAutoplayStopped = true;
                            }
                        })
                    }
                }
            });
        } else if(_state.isTablet && sliderTablet){
            swiper = _libs._swiper(sliderDesk, {
                slidesPerView: 4,
                speed: 800,
                spaceBetween: 10,
                centeredSlides: true,
                keyboard: {
                    enabled: true,
                },
                on: {
                    init: swiper => {},
                }
            });
        } else if(_state.isMobile && sliderMobile){
            swiper = _libs._swiper(sliderDesk, {
                slidesPerView: 1,
                speed: 800,
                keyboard: {
                    enabled: true,
                },
                on: {
                    init: swiper => {}
                }
            });
        }
    }

    createSwiper();

    const rebuildFunc = () => {
        if(viewportChecker.all()){
            createSwiper();
        }
    }
    _utils.rebuildComponentsOnResize(rebuildFunc);
}